/*
  Cycles the messages in the header trust bar.

  Everything visual lives in the stylesheet -- this only moves `is-active` and
  `is-leaving` along the list. That keeps the layouts driven entirely by CSS,
  and means the bar still reads correctly with JavaScript disabled: the first
  message shows and stays.
*/
(function () {
  'use strict';

  // Matches the stylesheet: below this the bar shows one message at a time.
  const ROTATES_BELOW = '(max-width: 989px)';

  // Must match the transition duration on .value-props-bar__item.is-active.
  const SLIDE_MS = 600;

  function init(bar) {
    if (bar.dataset.vpbBound === 'true') return;
    bar.dataset.vpbBound = 'true';

    const items = Array.from(bar.querySelectorAll('.value-props-bar__item'));
    if (items.length < 2) return;

    const interval = Number(bar.dataset.interval) || 4000;
    const narrow = window.matchMedia(ROTATES_BELOW);

    let index = Math.max(
      0,
      items.findIndex((item) => item.classList.contains('is-active'))
    );
    let timer = null;

    // From 990px the bar is either hidden or laid out with every message
    // visible at once, and neither of those has anything to rotate.
    const rotating = () => narrow.matches;

    let leaveTimer = null;

    // Strip any half-finished exit, so a message can never be left carrying
    // both classes and end up invisible on its next turn.
    const settle = () => {
      clearTimeout(leaveTimer);
      leaveTimer = null;
      items.forEach((item) => item.classList.remove('is-leaving'));
    };

    const stop = () => {
      clearInterval(timer);
      timer = null;
      settle();
    };

    const advance = () => {
      const outgoing = items[index];
      outgoing.classList.remove('is-active');
      outgoing.classList.add('is-leaving');
      // Once it has slid off to the left, drop the class to park it back on the
      // right, ready to enter from that side again.
      leaveTimer = setTimeout(() => outgoing.classList.remove('is-leaving'), SLIDE_MS);

      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    };

    const start = () => {
      stop();
      if (!rotating()) return;
      timer = setInterval(advance, interval);
    };

    narrow.addEventListener('change', start);

    // A bar in a background tab is burning a timer for nobody.
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    start();
  }

  function bindAll() {
    document.querySelectorAll('.value-props-bar').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  // The section re-renders when it is edited in the theme editor.
  document.addEventListener('shopify:section:load', bindAll);
})();
